import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Stats } from "./components/Stats";
import { Footer } from "./components/Footer";
import { ThankYou } from "./components/ThankYou";
import { QuizPromo } from "./components/QuizPromo";
import { TypeformEmbed } from "./components/TypeformEmbed";
import { FloatingCTA } from "./components/FloatingCTA";
import { MortgageCalculator } from "./components/calculators/MortgageCalculator";
import { CompoundCalculator } from "./components/calculators/CompoundCalculator";
import { LoanCalculator } from "./components/calculators/LoanCalculator";
import { BudgetCalculator } from "./components/calculators/BudgetCalculator";
import { InsuranceCalculator } from "./components/calculators/InsuranceCalculator";
import { IncomeExpenseCalculator } from "./components/calculators/IncomeExpenseCalculator";
import { RetirementCalculator } from "./components/calculators/RetirementCalculator";
import { InflationCalculator } from "./components/calculators/InflationCalculator";
import { SavingsGoalCalculator } from "./components/calculators/SavingsGoalCalculator";
import { FireCalculator } from "./components/calculators/FireCalculator";
import { DebtPayoffCalculator } from "./components/calculators/DebtPayoffCalculator";
import { NetSalaryCalculator } from "./components/calculators/NetSalaryCalculator";
import { Toaster } from "./components/ui/sonner";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-navy">
      <Header />
      <Hero />
      <Stats />
      
      {/* Calculators Section */}
      <section className="py-12 md:py-16" data-testid="calculators-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section header */}
          <div className="text-center mb-10">
            <h2 className="font-serif text-2xl md:text-3xl font-bold text-white mb-3">
              12 finančních kalkulaček
            </h2>
            <p className="text-gray-400">
              Vyberte si kalkulačku a spočítejte si to sami
            </p>
          </div>

          <div className="space-y-4">
            {/* Investment Calculator - Open by default */}
            <CompoundCalculator />
            
            {/* Other calculators - Collapsed by default */}
            <MortgageCalculator />
            <LoanCalculator />
            <BudgetCalculator />
            <SavingsGoalCalculator />
            <FireCalculator />
            <DebtPayoffCalculator />
            <NetSalaryCalculator />
            <InsuranceCalculator />
            <IncomeExpenseCalculator />
            <RetirementCalculator />
            <InflationCalculator />
          </div>
        </div>
      </section>

      {/* Quiz Promo */}
      <QuizPromo />

      {/* Typeform Embed */}
      <TypeformEmbed />

      <Footer />
      <FloatingCTA />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dekujeme" element={<ThankYou />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
